import { put } from 'redux-saga/effects';
import { fetchWarehouseSnapshot } from '../../felles/APICalls_NV04';
import * as actions from '../actions';
import * as actionTypesNV04 from '../actions/actionTypesNV04';
import * as actionsNV04 from '../actions/indexNV04';

export function* fetchSnapshotSaga(action) {
  try {
    yield put(actions.setIsloading(true));

    const { companyId, selectedYear, selectedMonth } = action.payload;
    const response = yield fetchWarehouseSnapshot(companyId, selectedYear, selectedMonth);

    if (response) {
      yield put(actionsNV04.fetchSnapshotSuccess(response));
    } else {
      yield put(actionsNV04.fetchSnapshotFailure("No data received"));
    }
  } catch (error) {
    let errorMessage = "Unknown error";
    if ((error as any).response?.data) {
      const data = (error as any).response.data;
      if (typeof data === 'string') {
        errorMessage = data;
      } else if (data.message) {
        errorMessage = data.message;
      } else {
        errorMessage = JSON.stringify(data);
      }
    } else if ((error as any).response?.statusText) {
      errorMessage = (error as any).response.statusText;
    } else {
      errorMessage = (error as Error).message;
    }
    yield put(actionsNV04.fetchSnapshotFailure(errorMessage));
  } finally {
    yield put(actions.setIsloading(false));
  }
}
